import React from 'react'
import { Switch } from 'antd'
import styled from 'styled-components';
//@ts-ignore
import s from './SwitchStandardBase.module.scss'


let StyledSelect = styled(Switch)` 
    &.ant-switch{
        background-color: #E0E2E6 !important;
    } 
    &.ant-switch-checked{
        background-color: #425D76 !important;
    } 
    &.ant-switch:focus {
        box-shadow: 0 0 0 2px rgb(226 226 226 / 10%) !important;
    } 
    &.ant-switch-checked:focus{
        box-shadow: 0 0 0 2px rgb(66 93 118 / 10%)  !important;
    }
     &.ant-switch .ant-click-animating-node{
        box-shadow: 0 0 0 2px  #425D76 !important;
        -webkit-animation: fadeEffect 2s cubic-bezier(0.08, 0.82, 0.17, 1), waveEffect 0.4s cubic-bezier(0.08, 0.82, 0.17, 1)  !important;
    }
    @keyframes waveEffect{
        100% {box-shadow: 0 0 0 6px #425d76; !important; }
    }
`;



type SwitchStandardT = {
    label: string
    onChange: any
    checked?: boolean
}

export const SwitchStandardBase = ({ ...props }: SwitchStandardT) => {

    const { label, onChange, checked } = props;

    return (
        <div className={s.switch_wrap}>
            <StyledSelect checked={checked} onChange={() => onChange()} />
            <div className={s.switch_name} >{label}</div>
        </div>
    )
}

